import { ReactNode, useState } from 'react';
import { Image, Platform, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { Footer } from './Footer';
import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import { isPatientApp } from '@/config/constants';

export const LoginLayout = ({ children }: { children: ReactNode }) => {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const extraHeight = useResponsiveHeight(30);
  const padding = isPatientApp ? 40 : useResponsiveWidth(2.5);

  return (
    <View className="bg-blue-neolexonLight flex-1 bg-blue-neolexonlight">
      {!isKeyboardVisible && (
        <View className="h-16 my-5">
          <Image
            source={require('../../assets/neolexon_Logo_ohneClaim.png')}
            style={{
              flex: 1,
              width: '100%',
              height: '100%',
              resizeMode: 'contain',
            }}
          />
        </View>
      )}
      <KeyboardAwareScrollView
        enableOnAndroid
        extraHeight={extraHeight}
        onKeyboardDidHide={() => setIsKeyboardVisible(false)}
        onKeyboardDidShow={() => setIsKeyboardVisible(true)}
      >
        <View className="items-center justify-center flex-1 ">
          <View
            className="max-w-[853px] w-full bg-white rounded-3xl overflow-hidden "
            style={{ padding }}
            role={Platform.OS === 'web' ? 'form' : undefined}
          >
            {children}
          </View>
        </View>
      </KeyboardAwareScrollView>
      {!isKeyboardVisible && (
        <View className="px-6">
          <Footer />
        </View>
      )}
    </View>
  );
};
